// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

interface Props {
  width?: number;
  height?: number;
  onClick?: VoidFunction;
}

export const IconICCardScanHistory = ({
  width = 16,
  height = 16,
  onClick,
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
    >
      <path
        d="M4 16C4.55228 16 5 16.4477 5 17V19H7C7.55228 19 8 19.4477 8 20C8 20.5523 7.55228 21 7 21H4.2002C3.53745 21 3 20.4625 3 19.7998V17C3 16.4477 3.44772 16 4 16ZM20 16C20.5523 16 21 16.4477 21 17V19.7998C21 20.4625 20.4625 21 19.7998 21H17C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19H19V17C19 16.4477 19.4477 16 20 16ZM7 3C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5H5V7C5 7.55228 4.55228 8 4 8C3.44772 8 3 7.55228 3 7V4.2002C3 3.53745 3.53745 3 4.2002 3H7ZM19.7998 3C20.4625 3 21 3.53745 21 4.2002V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H17C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3H19.7998Z"
        fill="#6F6F6F"
      />
      <path
        d="M8.30701 6.69727C8.8591 6.69736 9.30682 7.14519 9.30701 7.69727V8.49121C10.2005 7.78512 11.3277 7.36152 12.5551 7.36133C15.454 7.36133 17.8038 9.7115 17.8041 12.6104C17.8041 15.5094 15.4541 17.8594 12.5551 17.8594C10.4254 17.859 8.59343 16.5902 7.77087 14.7676C7.56874 14.3193 7.82965 13.8198 8.28845 13.6426C8.84965 13.4261 9.46664 13.7851 9.77966 14.2988C10.3496 15.2345 11.3793 15.8591 12.5551 15.8594C14.3495 15.8594 15.8041 14.4048 15.8041 12.6104C15.8038 10.8161 14.3494 9.36133 12.5551 9.36133C11.8211 9.36151 11.1447 9.60591 10.601 10.0166H11.6263C12.1783 10.0167 12.626 10.4647 12.6263 11.0166C12.6263 11.5688 12.1786 12.0165 11.6263 12.0166H8.80701C7.97858 12.0166 7.30701 11.345 7.30701 10.5166V7.69727C7.30719 7.14514 7.75484 6.69727 8.30701 6.69727Z"
        fill="#6F6F6F"
      />
    </svg>
  );
};
